import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const preloadImages = (srcArray) => {
  srcArray.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};

const AlertModal = ({ show, titleText, alertText, onClose }) => {
  useEffect(() => {
    preloadImages(['images/warning.gif', 'images/success-2.gif', 'images/Error.gif']);
  }, []);

  const handleKeyDown = (e) => {
    // Prevent closing the modal on Enter or Escape keys
    if (e.key === 'Enter' || e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return (
    <Modal
      fade={false}
      className="newmodal"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onClose}
      backdrop="static" 
      keyboard={false} 
    >
      <Modal.Header>
        <Modal.Title></Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="p-1 d-flex flex-column justify-content-center align-items-center text-center"
        style={{
          // maxWidth: '90%',
          // wordWrap: 'break-word',
          // overflowWrap: 'break-word',
          // overflowY: 'auto',
          // maxHeight: '300px', // Prevents the modal from growing too large
          padding: '10px'
        }}
        onKeyDown={handleKeyDown}
      >
        <div
          className="text-center"
          // style={{
          //   maxWidth: '100%',
          //   overflow: 'hidden',
          //   textAlign: 'center'
          // }}
        >
          {titleText === 'warning' ? (
            <img src="images/warning.gif" style={{ width: '70px', marginBottom: '10px' }} alt="Warning Icon" />
          ) : titleText === 'success' ? (
            <img src="images/success-2.gif" style={{ width: '70px', marginBottom: '10px' }} alt="Success Icon" />
          ) : (
            <img src="images/Error.gif" style={{ width: '70px', marginBottom: '10px' }} alt="Error Icon" />
          )}
          <p
            className="fw-bold"
            style={{
              fontSize: '14px',
              // wordWrap: 'break-word',
              // overflowWrap: 'break-word',
              // overflowY: 'auto',
              // textAlign: 'center',
              // maxWidth: '100%'
            }}
          >
            {alertText}
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="confirm" onClick={onClose}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertModal;
